import React from 'react';
import { ExternalLink } from 'lucide-react';

// WellnessLiving info-session registration (no commitment).
export const INFO_SESSION_URL =
  'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=981136&k_class_tab=75840';

/**
 * Reusable "Sign up for a free info session" link button.
 * variant: 'solid' (forest) | 'outline' (light)
 */
const InfoSessionButton = ({
  variant = 'outline',
  className = '',
  label = 'Sign Up for a Free Info Session — No Commitment',
  testId = 'info-session-signup-link',
}) => {
  const base =
    'inline-flex items-center justify-center gap-2 font-body font-medium rounded-full transition-colors px-5 py-2.5 text-sm';
  const styles =
    variant === 'solid'
      ? 'bg-forest text-cream hover:bg-forest-dark'
      : 'bg-white border border-forest/30 text-forest hover:border-forest';
  return (
    <a
      href={INFO_SESSION_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${styles} ${className}`}
      data-testid={testId}
    >
      {label} <ExternalLink size={14} />
    </a>
  );
};

export default InfoSessionButton;
